import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { hoslogPlanRequestQueries } from '@/services/hoslog-plans/hoslog-plans-request.queries';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useHoslogPlanRequestMutation = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('updatePlanRequest', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: hoslogPlanRequestQueries.all() });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsync, isPending };
};

export default useHoslogPlanRequestMutation;
